import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsbStatusEnum } from "@/utils/enums/IndicatorEsbStatusEnum";

export type ResumeCitizensAttendancesIndicatorB2Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class ResumeCitizenAttendancesIndicatorB2Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";

	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	treatmentStartDate: string = "";
	treatmentEndDate: string = "";
	lastDentalAttendanceStatus: IndicatorEsbStatusEnum = IndicatorEsbStatusEnum.Lost;
}

export async function getResumeCitizensAttendancesIndicatorB2({
	uf,
	ibgeCode,
	...params
}: ResumeCitizensAttendancesIndicatorB2Params) {
	const response = await esusApi.get<Paginated<ResumeCitizenAttendancesIndicatorB2Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b2/resume-citizens-attendances`,
		params
	);
	return response.data ?? new Paginated<ResumeCitizenAttendancesIndicatorB2Data>();
}
